import {adminHttpClient} from "../commons/adminHttpClient";


const deleteAuditee = (id : string) : Promise<any> => {
    return adminHttpClient.delete(`/Auditees/Delete`, {
        data:{id : id}
    })
}

export default deleteAuditee;